import { Component, Input } from '@angular/core'
import { FormFieldComponent } from '@widgets/form-field/form-field.component'

@Component({
  selector: 'bdg-input-field-number',
  templateUrl: './input-field-number.component.html',
})
export class InputFieldNumberComponent extends FormFieldComponent {
  @Input()
  min: number

  @Input()
  max: number

  @Input()
  maxLength: number

  constructor() {
    super()
  }

  get error() {
    return this.control?.touched && this.control?.errors?.error
  }

  onChange(value) {
    if (this.maxLength) {
      this.control.patchValue(value.slice(0, this.maxLength))
    }
  }
}
